<div class="dashletFlip__container">
  <div
    id="dashlet-flip__card"
    [ngClass]="{
      flipped: isFlipped,
      classicDashlet:
        ppDashlet.name === dashletTypes.ACTIVITIES ||
        ppDashlet.name === dashletTypes.CURRENT_STATUS ||
        ppDashlet.name === dashletTypes.CURRENT_PRIORITY ||
        ppDashlet.name === dashletTypes.OVER_TIME_STATUS ||
        ppDashlet.name === dashletTypes.OVER_TIME_PRIORITY ||
        ppDashlet.name === dashletTypes.VALUE_BREAKDOWN ||
        ppDashlet.name === dashletTypes.COST_COMPARISON,
    }"
  >
    <div class="dashlet-flip__content-wrapper dashletFlip__front">
      <pp-dashlet-head
        [ppCanEdit]="ppCanEdit"
        [ppAssetId]="ppAssetId"
        [ppDashlet]="ppDashlet"
        [ppAccountName]="account?.accountName"
        [ppWorkspaces]="
          ppDashlet.selectedRange.workspaceId
            ? [ppDashlet.selectedRange.workspaceId]
            : ppDashlet.selectedRange.workspaceIds
        "
        (ppToggleFlip)="toggleFlip()"
      >
      </pp-dashlet-head>

      @if (ppDashlet.name === dashletTypes.ACTIVITIES) {
        <pp-dashlet-activities
          [ppAccountId]="selectedRange?.accountId"
          [ppWorkspaceIds]="selectedRange?.workspaceIds"
          [ppLoading]="loading"
          [ppDashlet]="ppDashlet"
        ></pp-dashlet-activities>
      }

      @if (
        ppDashlet.name === dashletTypes.DEFECT_CREATE ||
        ppDashlet.name === dashletTypes.COMMENT_CREATE ||
        ppDashlet.name === dashletTypes.HIGH ||
        ppDashlet.name === dashletTypes.MEDIUM ||
        ppDashlet.name === dashletTypes.LOW ||
        ppDashlet.name === dashletTypes.OPEN ||
        ppDashlet.name === dashletTypes.IN_PROGRESS ||
        ppDashlet.name === dashletTypes.TO_REVIEW ||
        ppDashlet.name === dashletTypes.ONHOLD ||
        ppDashlet.name === dashletTypes.CLOSED ||
        ppDashlet.name === dashletTypes.CANCELED
      ) {
        <div class="dashletBody__container">
          <div class="dashletBody">
            <pp-dashlet-events
              [ppDashlet]="ppDashlet"
              [ppPeriod]="ppDashlet.period"
              [ppAccountId]="selectedRange?.accountId"
              [ppWorkspaceIds]="selectedRange?.workspaceIds"
              [ppLoading]="loading"
            >
            </pp-dashlet-events>
          </div>
        </div>
      }

      @if (
        ppDashlet.name === dashletTypes.OVER_TIME_STATUS ||
        ppDashlet.name === dashletTypes.OVER_TIME_PRIORITY ||
        ppDashlet.name === dashletTypes.CURRENT_STATUS ||
        ppDashlet.name === dashletTypes.CURRENT_PRIORITY ||
        ppDashlet.name === dashletTypes.CURRENT_STACKED_STATUS ||
        ppDashlet.name === dashletTypes.COST_COMPARISON ||
        ppDashlet.name === dashletTypes.VALUE_BREAKDOWN
      ) {
        <div class="dashletBody__container">
          <div class="dashletBody dashletBody__graphs">
            @if (
              ppDashlet.name === dashletTypes.OVER_TIME_STATUS ||
              ppDashlet.name === dashletTypes.OVER_TIME_PRIORITY ||
              ppDashlet.name === dashletTypes.CURRENT_STACKED_STATUS ||
              ppDashlet.name === dashletTypes.COST_COMPARISON ||
              ppDashlet.name === dashletTypes.CURRENT_STATUS ||
              ppDashlet.name === dashletTypes.CURRENT_PRIORITY ||
              ppDashlet.name === dashletTypes.VALUE_BREAKDOWN
            ) {
              <div class="dashletBody__chart">
                <canvas #chart width="400" height="400"></canvas>
              </div>
            }
            @if (showingEmptyCostComparisonMessage) {
              <pp-dashlet-cost-comparison-setup
                (ppEditDashlet)="setupCostComparison()"
                [ppCanEdit]="ppCanEdit"
                ppHeaderKey="cost_comparison_setup_header"
              ></pp-dashlet-cost-comparison-setup>
            }
            @if (showingWrongCurrenciesError) {
              <pp-dashlet-cost-comparison-wrong-currencies
                (ppEditDashlet)="setupCostComparison()"
              ></pp-dashlet-cost-comparison-wrong-currencies>
            }
            @if (showingWrongValueBreakdownError) {
              <pp-dashlet-cost-comparison-setup
                (ppEditDashlet)="setupEditValueBreakdownDashlet()"
                [ppCanEdit]="ppCanEdit"
                ppHeaderKey="value_breakdown_setup_header"
              ></pp-dashlet-cost-comparison-setup>
            }
          </div>
          @if (
            ppDashlet.name === dashletTypes.CURRENT_STATUS ||
            ppDashlet.name === dashletTypes.CURRENT_PRIORITY ||
            ppDashlet.name === dashletTypes.OVER_TIME_STATUS ||
            ppDashlet.name === dashletTypes.OVER_TIME_PRIORITY
          ) {
            <div class="dashletBody__totalPoints">
              {{ 'total_points_number' | ppTranslate: { totalPoints: totalPoints } }}
            </div>
          }
        </div>
      }
    </div>

    <pp-dashlet-flip
      [ppAssetId]="ppAssetId"
      [ppDashlet]="ppDashlet"
      [ppFlipped]="isFlipped"
      (ppToggleFlip)="toggleFlip()"
      [ppDefaultWorkspaces]="ppDefaultWorkspaces"
      (ppSelectPeriod)="selectPeriod($event)"
      (ppSelectSiteRange)="selectSiteRange($event)"
      (ppDashletNameChange)="updateDashletName($event)"
    >
    </pp-dashlet-flip>
  </div>
</div>
